import DOMPurify from 'dompurify';
import styled from 'styled-components';

import { Button } from '@sorare/core/src/atoms/buttons/Button';
import { FontAwesomeIcon } from '@sorare/core/src/atoms/icons';
import { iconChevronLeft } from '@sorare/core/src/atoms/icons/system/iconChevronLeft.ts';
import { HeadlineXL, LabelL } from '@sorare/core/src/atoms/typography';

import type { Job } from '#src/Careers/types.ts';
import { Section, StyledContainer } from '#src/Careers/ui.tsx';

type Props = {
  job: Job;
};

const Container = styled.div`
  & p {
    margin: revert;
  }

  & li {
    list-style-type: circle;
  }
`;

const Compensation = styled.div`
  margin-bottom: var(--quadruple-unit);

  & p {
    margin: revert;
  }
`;

const ButtonContainer = styled.div`
  margin-bottom: var(--quadruple-unit);
`;

export const JobForm = ({ job }: Props) => {
  const compensationSummary =
    job.compensation?.compensationTiers?.find(
      tier => tier.title === job.location
    )?.tierSummary || job.compensation?.compensationTierSummary;

  return (
    <Section $spacing>
      <StyledContainer>
        <ButtonContainer>
          <Button
            color="primary"
            size="small"
            startIcon={<FontAwesomeIcon icon={iconChevronLeft} />}
            to="#jobs"
          >
            View all Jobs
          </Button>
        </ButtonContainer>
        <HeadlineXL as="h2">{job.title}</HeadlineXL>
        <LabelL bold>{job.employmentType}</LabelL>
        {/* oxlint-disable-next-line react/no-danger */}
        <Container
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(job.descriptionHtml),
          }}
        />
        {!!compensationSummary && (
          <Compensation>
            <h2>Compensation</h2>
            <p>{compensationSummary}</p>
            <p>
              The compensation is a reasonably estimated salary for this role at
              Sorare and will include a competitive equity package. Actual
              compensation is based on factors such as the candidate’s skills,
              qualifications, and experience. In addition, Sorare offers a wide
              range of best in class, comprehensive and inclusive employee
              benefits for this role including healthcare, parental leave, a
              generous vacation policy, fitness reimbursements, commuter
              benefits and contribution to lunch expenses!
            </p>
          </Compensation>
        )}
        <Button color="primary" size="medium" href={job.applyUrl} externalLink>
          Apply
        </Button>
      </StyledContainer>
    </Section>
  );
};
